import { render } from "./ModalInformationContent.vue?vue&type=template&id=db4d7526&scoped=true"
import script from "./ModalInformationContent.vue?vue&type=script&lang=js"
export * from "./ModalInformationContent.vue?vue&type=script&lang=js"

import "./ModalInformationContent.vue?vue&type=style&index=0&id=db4d7526&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db4d7526"]])

export default __exports__